<template>
  <div>
    <v-card
      :style="{
        backgroundColor: '#ffffff',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',
      }"
    >
      <!-- Header with profile info -->
      <div
        class="px-3 pb-1 pt-2 d-flex justify-space-between align-center"
        style="position: relative"
      >
        <div class="d-flex" style="gap: 5px">
          <div
            class="d-flex align-center justify-space-between"
            style="min-width: 250px"
            v-if="recurring != false && !auto_variation"
          >
            <div class="d-flex align-center" style="gap: 2px">
              <v-btn
                size="small"
                :disabled="tab === 0 || thinking"
                @click="tab = tab - 1"
                variant="text"
                icon
                ><v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <p class="mb-0 pb-0" style="font-size: 9pt; opacity: 0.7">
                <span
                  class="mb-0 pb-0 text-grey-darken-1"
                  style="font-size: 9pt"
                  >Variation</span
                >
                <span class="ml-1 font-weight-bold"
                  >{{ tab + 1 }}/{{ variations.length }}</span
                >
              </p>
              <v-btn
                size="small"
                :disabled="tab === variations.length - 1 || thinking"
                @click="tab++"
                variant="text"
                icon
                ><v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <v-spacer></v-spacer>

            <v-menu transition="slide-y-transition" bottom offset-y>
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  size="small"
                  variant="text"
                  :disabled="thinking"
                  ><v-icon size="15" color="primary">mdi-plus</v-icon></v-btn
                >
              </template>
              <v-list>
                <div>
                  <v-list-item dense link class="px-4" @click="addVariation">
                    <v-list-item-title style="font-size: 10pt">
                      <v-icon class="mr-2" size="20" color="primary"
                        >mdi-note-outline</v-icon
                      >
                      Add empty variation</v-list-item-title
                    >
                  </v-list-item>

                  <v-list-group value="generate-variation">
                    <template v-slot:activator="{ props }">
                      <v-list-item
                        v-bind="props"
                        density="compact"
                        link
                        class="px-4"
                      >
                        <v-list-item-title style="font-size: 10pt">
                          <v-icon class="mr-2">
                            <v-img
                              max-width="20"
                              height="20"
                              style="color: #272727"
                              :src="require('@/assets/icons/openai.svg')"
                            ></v-img>
                          </v-icon>
                          Generate variation
                        </v-list-item-title>
                      </v-list-item>
                    </template>

                    <v-list-item
                      density="compact"
                      link
                      class="px-6"
                      @click="generateVariation('light')"
                    >
                      <v-list-item-title style="font-size: 10pt">
                        Light changes
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      density="compact"
                      link
                      class="px-6"
                      @click="generateVariation('medium')"
                    >
                      <v-list-item-title style="font-size: 10pt">
                        Medium changes
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      density="compact"
                      link
                      class="px-6"
                      @click="generateVariation('heavy')"
                    >
                      <v-list-item-title style="font-size: 10pt">
                        Heavy changes
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-group>
                </div>
              </v-list>
            </v-menu>
            <div>
              <v-btn
                size="small"
                icon
                @click="undo"
                variant="text"
                :disabled="currentVariation?.undo?.length === 0 || thinking"
                ><v-icon color="primary" size="15">mdi-undo</v-icon>
              </v-btn>
              <v-btn
                size="small"
                icon
                @click="redo"
                variant="text"
                :disabled="currentVariation?.redo?.length === 0 || thinking"
                ><v-icon color="primary" size="15">mdi-redo</v-icon>
              </v-btn>
              <v-menu transition="slide-y-transition" bottom offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn size="small" icon v-bind="props" variant="text"
                    ><v-icon color="primary" size="15">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <div v-for="(i, index) in variations" :key="index">
                    <v-list-item
                      density="compact"
                      link
                      class="px-4"
                      @click="removeVariation(index)"
                    >
                      <v-list-item-title style="font-size: 10pt">
                        {{ index + 1 }}</v-list-item-title
                      >
                    </v-list-item>
                  </div>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>

        <div class="d-flex align-center" style="gap: 5px">
          <EmojiPickerDialog @insert="insert" />
        </div>
      </div>
      <v-divider></v-divider>
      <!-- Post content area -->
      <div class="px-4 pb-2">
        <v-textarea
          v-model="currentVariation.text"
          placeholder="What do you want to talk about?"
          variant="plain"
          hide-details
          @input="(event) => updateHistory(event.target.value)"
          auto-grow
          width="100%"
          :disabled="thinking"
          rows="20"
          style="font-size: 10pt; color: #191919"
          class="linkedin-textarea pt-0"
          @keydown.ctrl.z.prevent="undo"
          @keydown.ctrl.shift.z.prevent="redo"
          @keydown.meta.z.prevent="undo"
          @keydown.meta.shift.z.prevent="redo"
        >
        </v-textarea>
      </div>

      <!-- Action buttons -->
      <div class="bottom">
        <v-divider></v-divider>
        <!-- <div class="d-flex justify-space-between pa-3">
          <div class="d-flex align-center" style="gap: 4px">
            <v-avatar size="28">
              <v-img
                src="https://randomuser.me/api/portraits/men/32.jpg"
                alt="User"
              ></v-img>
            </v-avatar>
            <v-icon size="16" color="#666666">mdi-menu-down</v-icon>
          </div>
          <v-btn
            variant="text"
            size="small"
            prepend-icon="mdi-thumb-up-outline"
            color="#666666"
            style="font-size: 9pt; font-weight: 500"
            disabled
          >
            <template #prepend>
              <v-icon size="14" color="#666666">mdi-thumb-up-outline</v-icon>
            </template>
            Like
          </v-btn>
          <v-btn
            variant="text"
            size="small"
            prepend-icon="mdi-comment-outline"
            color="#666666"
            style="font-size: 9pt; font-weight: 500"
            disabled
          >
            <template #prepend>
              <v-icon size="14" color="#666666">mdi-comment-outline</v-icon>
            </template>
            Comment
          </v-btn>
          <v-btn
            variant="text"
            size="small"
            prepend-icon="mdi-repeat"
            color="#666666"
            style="font-size: 9pt; font-weight: 500"
            disabled
          >
            <template #prepend>
              <v-icon size="14" color="#666666">mdi-repeat</v-icon>
            </template>
            Repost
          </v-btn>
          <v-btn
            variant="text"
            size="small"
            prepend-icon="mdi-send-outline"
            color="#666666"
            style="font-size: 9pt; font-weight: 500"
            disabled
          >
            <template #prepend>
              <v-icon size="14" color="#666666">mdi-send-outline</v-icon>
            </template>
            Send
          </v-btn>
        </div> -->
      </div>
    </v-card>
  </div>
</template>

<script>
import { post } from "@/mixins/post";
import { mapState } from "vuex";
import EmojiPickerDialog from "@/components/EmojiPicker.vue";

export default {
  name: "LinkedinPostEditor",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [post],
  components: {
    EmojiPickerDialog,
  },
  data() {
    return {
      // No need for local postContent anymore
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      structures: (state) => state.structures.structures,
      structures_loading: (state) => state.loading.structures,
      drawer: (state) => state.structures.show,
      accounts: (state) => state.accounts.accounts,
      variations: (state) => state.post.variations,
      selected_accounts: (state) => state.post.selected_accounts,
    }),

    currentDate() {
      const now = new Date();
      const options = { month: "short", day: "numeric" };
      return now.toLocaleDateString("en-US", options);
    },
    filteredAccounts() {
      console.log(this.accounts);
      return this.accounts.filter((account) =>
        this.selected_accounts.includes(account.id),
      );
    },
    currentVariation() {
      return this.variations[this.tab];
    },
  },
  methods: {
    addVariation() {
      this.variations.push({
        text: "",
        type: "variation",
        loading: false,
        uid: this.variations.length.toString(),
        created_at: null,
        media: null,
        undo: [""],
        redo: [],
      });
      const vm = this;
      setTimeout(() => {
        vm.tab = vm.variations.length - 1;
      }, 150);
    },
    removeVariation(i) {
      this.variations.splice(i, 1);
      if (this.variations.length === 0) {
        this.variations.push({
          text: "",
          type: "main",
          loading: false,
          uid: "0",
          created_at: null,
          media: null,
          undo: [""],
          redo: [],
        });
      }
      if (this.tab === i || this.tab >= this.variations.length) {
        this.tab = this.variations.length - 1;
      }
    },
    removeAccount(id) {
      this.selected_accounts = this.selected_accounts.splice(
        this.selected_accounts.findIndex((a) => a === id),
        1,
      );
    },
    clearText() {
      let r = confirm("Are you sure you want to clear the text?");
      if (r) {
        this.currentVariation.text = "";
      }
    },
    getDomain(url) {
      if (!url) return "";
      try {
        const domain = new URL(url).hostname;
        return domain.replace("www.", "");
      } catch {
        return url;
      }
    },
    getContent() {
      return this.currentVariation?.text || "";
    },
    undo() {
      if (!this.currentVariation.undo.length) return;
      this.currentVariation.redo.push(this.currentVariation.text);
      this.currentVariation.text = this.currentVariation.undo.pop();
    },
    redo() {
      if (!this.currentVariation.redo.length) return;
      this.currentVariation.undo.push(this.currentVariation.text);
      this.currentVariation.text = this.currentVariation.redo.pop();
    },
    insert(emoji) {
      // Insert emoji at cursor position or at the end
      const textarea = this.$el.querySelector(".linkedin-textarea textarea");
      if (textarea) {
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const text = this.currentVariation?.text || "";

        // Update the store directly
        if (this.currentVariation) {
          this.currentVariation.text =
            text.substring(0, start) + emoji + text.substring(end);
        }

        // Set cursor position after the inserted emoji
        this.$nextTick(() => {
          textarea.setSelectionRange(
            start + emoji.length,
            start + emoji.length,
          );
          textarea.focus();
        });
      } else {
        // Fallback: append to the end
        if (this.currentVariation) {
          this.currentVariation.text =
            (this.currentVariation.text || "") + emoji;
        }
      }
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    updateHistory(newValue) {
      console.log("updateHistory", newValue, this.currentVariation.text);
      if (
        this.currentVariation.undo[this.currentVariation.undo.length - 1] !==
        this.currentVariation.text
      ) {
        this.currentVariation.undo.push(this.currentVariation.text);
      }
      this.currentVariation.redo = [];

      this.currentVariation.text = newValue;
      console.log("currentVariation", this.currentVariation);
    },
  },
  watch: {
    // Watch for changes in the store's variations to emit updates
    currentVariation: {
      handler(newVariation) {
        if (newVariation && newVariation.text) {
          this.$emit("update:content", newVariation.text);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.linkedin-textarea :deep(.v-field__input) {
  min-height: 120px !important;

  font-size: 11pt !important;
  color: #191919 !important;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif !important;
  line-height: 1.4 !important;
}

.linkedin-textarea :deep(.v-field__input::placeholder) {
  color: #666666 !important;
  font-size: 11pt !important;
}

.linkedin-textarea :deep(.v-field) {
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

.linkedin-textarea :deep(.v-field__outline) {
  display: none !important;
}

.media-preview {
  border-top: 1px solid #e0e0e0;
  margin-top: 8px;
}

.link-preview {
  transition: all 0.2s ease;
}

.link-preview:hover {
  background-color: #f0f0f0 !important;
  cursor: pointer;
}

/* LinkedIn-style button hover effects */
.v-btn:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
}
</style>
